<template>
	<information-card
		class="factors-weighting"
	>
		<div slot="content">
			<div class="tw-text-center factors-weighting-header">
				<span class="step-circle">2</span>
				<p class="text-primary font-weight-bold tw-m-0">Ponderación de factores</p>
				<p class="text-secondary tw-m-0">Puntos a Ponderar: 1000 puntos</p>
			</div>
			<div class="tw-pt-4">
				<weigh-factor-list
					:selected-factors="selectedFactors"
					:combinations="combinations"
				/>
			</div>
		</div>
		<div slot="footer" class="tw-text-center">
			<v-btn class="custom-button black" @click="back">Atrás</v-btn>
			<v-btn class="custom-button" color="primary" @click="next" :disabled="!weighingIsFinished">Siguiente</v-btn>
		</div>
	</information-card>
</template>

<script>
import InformationCard from '@/modules/shared/components/content/InformationCard';
import WeighFactorList
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighFactorList';
import { combinationsAreFilled } from '@/modules/job-evaluation/utils/valuation-model/factors';

export default {
	name: 'FactorsWeightingDescriptionNavigation',
	components: { WeighFactorList, InformationCard },
	props: ['selectedFactors', 'combinations'],
	methods: {
		next() {
			this.goTo('job-supply-valuation-model-degrees');
		},
		back() {
			this.goTo('job-supply-valuation-model-factors-choice');
		},
	},
	computed: {
		weighingIsFinished() {
			return combinationsAreFilled(this.combinations);
		},
	},
};
</script>

<style lang="scss" scoped>
.factors-weighting {
	.factors-weighting-header {
		p {
			line-height: 16px;
		}
		padding-bottom: 10px;
		border-bottom: 1px solid var(--app-color-gray);
		margin-bottom: 10px;
	}
	.step-circle {
		display: inline-flex;
		width: 40px;
		height: 40px;
		border: 1px solid var(--app-color-primary);
		border-radius: 50%;
		justify-content: center;
		align-items: center;
		font-size: 20px;
		background-color: var(--app-color-primary);
		color: white;
		margin-bottom: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/FactosWeightingDescriptionNavigation.vue